module.exports = __webpack_public_path__ + "img/grade.1293073d.svg";